import React from 'react';
import Us1_st_types from './us1_st_types';

const Us1_st = () => {
  return (
    <div>
      <Us1_st_types />
    </div>
  );
}

export default Us1_st;
